import React from 'react';
import { Route, Switch } from 'react-router';

import PasswordRequest from './clientPasswordReset/PasswordRequest';
import PasswordReset from './clientPasswordReset/PasswordReset';

export default ({ match }) => (
  <Switch>
    <Route exact path={`${match.url}`} component={PasswordRequest} />
    <Route path={`${match.url}/:token`} component={PasswordReset} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/components/routes/ClientPasswordReset.js